import React from "react";
import { Box } from "@mui/material";
import Hero from "./Hero";
import Features from "./Features";
import { Contact } from "./Contact";

const HomePage: React.FC = () => {

  return (
    <Box>      
      {/* Hero Section */}
      <Hero />
      {/* Features Section */}
      <Features />
      <Contact />
    </Box>
  );
};

export default HomePage;
